import React from 'react';

import { SVGComponentProps } from './svg.types';

const ShareOneSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherProps
}: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M2.57658 9.08201C3.21923 9.08019 3.83758 8.84823 4.30839 8.43234L8.90794 10.9311C8.58937 12.1147 9.23306 13.3411 10.4193 13.8107C11.6055 14.2804 12.9745 13.8508 13.6337 12.802C14.2928 11.7533 14.0421 10.4036 13.0451 9.63284C12.0481 8.86213 10.6072 8.90422 9.6618 9.73167L5.06225 7.23291C5.11047 7.05761 5.1371 6.87757 5.1416 6.69641L9.66106 4.24096C10.5581 5.01632 11.9038 5.08821 12.8866 4.41328C13.8694 3.73835 14.2205 2.50115 13.7282 1.44782C13.2359 0.394487 12.0348 -0.186948 10.8493 0.0541685C9.66372 0.295285 8.81793 1.29302 8.82197 2.44566C8.8246 2.6469 8.85347 2.84705 8.90794 3.04153L4.73161 5.30977C4.06261 4.32578 2.75345 3.93133 1.61046 4.36936C0.46747 4.8074 -0.188007 5.95477 0.0477532 7.10478C0.283513 8.2548 1.34423 9.08415 2.57658 9.08201Z"
        fill={fill}
      />
    </svg>
  );
};

export default ShareOneSVG;
